import React from 'react'


export default function Button() {
    return (
        <>
            <div className='grid grid-cols-1 py-14 md:grid-cols-3 gap-6 px-4 md:px-12 md:gap-14'>
                <div>
                    <button className='bg-orange-600 hover:bg-orange-500 rounded-lg text-white px-10 py-4 w-full text-3xl h-full'>Complete Career Guidance</button>
                </div>
                <div>
                    <button className='bg-orange-600 hover:bg-orange-500 rounded-lg text-white px-10 py-4 w-full text-3xl h-full'>24X7 Support</button>
                </div>
                <div>
                    <button className='bg-orange-600 hover:bg-orange-500 rounded-lg text-white px-10 py-4 w-full text-3xl h-full'>Free Counseling</button>
                </div>
            </div>
        </>
    )
}